// extracted by mini-css-extract-plugin
module.exports = {"wine":"release-module--wine--3YDrp","wineImage":"release-module--wineImage--2kKPe","proportions":"release-module--proportions--3iOQ-","wineRow":"release-module--wineRow--2eDyU"};